/*=========================================================================================
  File Name: moduleAdminMutations.js
  Description: Admin Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {

    SET_ADMIN(state, data) {
        state.adminUser = data.resultBody
        state.count = data.resultCount
    },
    SET_ADMIN_ROLE(state, data) {
        for (let index in data.resultBody) {
            data.resultBody[index].value = Number(data.resultBody[index].value)
        }

        state.adminRoleOptions = data.resultBody
    },
    SET_ADMIN_STATUS(state, data) {
        state.adminStatus = data.resultBody
    },
    SET_BLOCKED_REASON(state, data) {
        state.blockedReason = data.resultBody
    },
    SET_LOGIN_ADMIN_INFO(state, data) {
        state.loginAdminInfo = data
    }
}